import React from "react";
import { Box } from "@mui/material";
import caseErrorStyle from "./caseErrorStyle";

type CaseErrorProps = {
  errorMessage: string;
  errorStatus: number;
};
const CaseError = ({ errorMessage, errorStatus }: CaseErrorProps) => {
  return (
    <Box sx={caseErrorStyle.noCase}>
      <p>
        Leider ist ein technischer Fehler aufgetreten. Versuchen Sie bitte zunächst, die Seite mit STRG + F5 neu zu
        laden.
      </p>
      <p>
        Sollte nach erneutem Laden der Fehler noch auftreten, merken Sie sich bitte in welcher Situation der Fehler
        aufgetreten ist und kontaktieren Sie bitte die IT.
      </p>
      Fehler: "{errorMessage}" [{errorStatus}].
    </Box>
  );
};

export default CaseError;
